<script setup>
import EmojiOrIcon from 'shared/components/EmojiOrIcon.vue';

defineProps({
  title: {
    type: String,
    required: true,
  },
  compact: {
    type: Boolean,
    default: false,
  },
  icon: {
    type: String,
    default: '',
  },
  emoji: {
    type: String,
    default: '',
  },
  isOpen: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['toggle']);

const onToggle = () => {
  emit('toggle');
};
</script>

<template>
  <div class="text-sm bg-[#F9F9FB] dark:bg-transparent border !border-slate-100 dark:!border-[#27282D] rounded-xl shadow-sm overflow-visible mx-3 mb-4 p-4">
    <button
      class="flex items-center select-none w-full bg-transparent border-0 m-0 justify-between py-1.5 px-0 cursor-pointer group"
      @click.stop="onToggle"
    >
      <div class="flex items-center gap-1.5">
        <h5 class="text-n-slate-11 group-hover:text-n-slate-12 text-[13px] font-medium mb-0 py-0 pl-0 transition-colors">
          {{ title }}
        </h5>
        <span
          :class="[
            isOpen ? 'i-lucide-chevron-down' : 'i-lucide-chevron-right',
            'size-3.5 text-n-slate-11 group-hover:text-n-slate-12 transition-colors mt-0.5'
          ]"
        />
      </div>
      <div class="flex items-center gap-2">
        <slot name="button" />
        <span class="i-lucide-plus size-3.5 text-n-slate-11 hover:text-n-slate-12 transition-colors cursor-pointer" />
      </div>
    </button>
    <div
      v-if="isOpen"
      class="mt-2 text-n-slate-12"
      :class="compact ? 'p-0' : 'py-1'"
    >
      <slot />
    </div>
  </div>
</template>
